const data = {
  fflookup: {},
  timeOuts: {},
  directlinks: {},
};

export default data;